<div class="c-title--subsection text-uppercase">DETAILS</div>
<div class="row row--builder">
    <div class="col--builder col-sm-12">
        <div class="c-form-group" *ngIf="sharedService.catalogLayoutConfig.vipUnit == 'list'">
            <ccl-simple-select ariaLabel="Featured Speakers"
                [listOfItems]="displayAs"
                (valueChange)="speakerDataConfig.displayAs = $event.value"
                [value]="speakerDataConfig.displayAs"
                [bindLabel]="'label'"
                [bindValue]="'code'"
                [isClearable]="false"
            >
            </ccl-simple-select>
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
        <div class="c-form-group" *ngIf="sharedService.catalogLayoutConfig.vipUnit == 'card'">
            <ccl-simple-select ariaLabel="Featured Speakers"
                [listOfItems]="displayAsHighlighted"
                (valueChange)="speakerDataConfig.displayAs = $event.value"
                [value]="displayAsHighlighted[0].code"
                [bindLabel]="'label'"
                [bindValue]="'code'"
                [isClearable]="false"
            >
            </ccl-simple-select>
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
</div>

<div class="highlighted-admin-session-list">
    <ccl-list
        #tempSpeakerList
        [list]="selectedSessions"
        [columns]="columns"
        [hideFilters]="true"
        [compact]="true"
        [hasSelectableColumns]="false"
        [draggable]="true"
        (filterChangeEvent)="loadFilteredSessions($event)"
        contentRef="contentRef"
        [showPagination]="false"
    >
        There are no {{ this.sharedService.sessionUrl == "highlighted" ? "Featured" : "Promoted" }} speakers selected.
        Click <a href="JAVASCRIPT:void(0)" (click)="openDrawer($event)">here</a> to start your selection(s).</ccl-list
    >
</div>
<ccl-basic-button
    (clickEvent)="openDrawer($event)"
    buttonStyle="c-btn-add--primary--small"
    [isDisabled]="false"
    *ngIf="selectedSessions.data != null && selectedSessions.data.length > 0 && !(selectedSessions.data.length == 20)"
>
    <span class="add-speaker-btn">Add more speaker(s)</span>
</ccl-basic-button>
